import { User } from "shared-ts-utils-authentication";
import { UnsupportedError } from "shared-ts-utils-core";
import { DateTimeISO } from "shared-ts-types";

export type IdentityUserId = string;

export interface IdentityUserDto {
  id: IdentityUserId;
  userName: string;
  email: string;
  emailConfirmed: boolean;
  accessFailedCount: number;
  lockoutEnd?: DateTimeISO | null;
}

export class IdentityUser implements User {
  id: string;
  name: string;
  email: string;
  emailConfirmed: boolean;

  constructor(args: IdentityUserDto) {
    this.id = args.id;
    this.email = args.email;
    this.emailConfirmed = args.emailConfirmed;
    this.name = args.userName;
    this.name = args.userName;
  }

  get accessToken(): string {
    throw new UnsupportedError("accessToken not supported by IdentityUser");
  }

  hasClaim(claim: string): boolean {
    return false;
  }

  hasRole(role: string): boolean {
    return false;
  }

  getRole(): string {
    throw new Error("Method not implemented.");
  }

  isSessionActive(): boolean {
    return false;
  }

  isAirmontEmployee(): boolean {
    return this.email.endsWith("@airmont.no");
  }
}
